<template>
  <div>
    <Welcome v-if="this.rows.length === 0" @click="addRow"></Welcome>
    <template v-else>
      <Row v-for="(row, i) in rows" :key="i" :number="i + 1" v-bind="row" @addSection="addSection(row, $event)" @update="updateRow(row, $event)" @copy="copyRow(row, i, $event)" @remove="removeRow(row, i)" @updateSection="updateSectionHandler(row, $event)"></Row>
      <AddRow v-if="hasSections" @click="addRow"></AddRow>
      <Accessories v-if="hasSections" :role="role" :pdfData="pdfData" :items="accessories" :wedgeAnchors.sync="wedgeAnchors" @print="print" @download="download"></Accessories>
      <EmailModal :pdfData="pdfData"></EmailModal>
      <DealerModal :pdfData="pdfData"></DealerModal>
      <InvoiceModal :inns="inns" :pdfData="pdfData"></InvoiceModal>
    </template>
  </div>
</template>

<script>
import './assets/tooltip-tippy.css';
import Welcome from './components/Welcome.vue'
import Row from './components/Row.vue'
import AddRow from './components/AddRow.vue'
import Accessories from './components/Accessories.vue'
import EmailModal from './components/EmailModal.vue'
import DealerModal from './components/DealerModal.vue'
import InvoiceModal from './components/InvoiceModal.vue'

function normalizeUrl(url) {
  var a = document.createElement('a');
  a.href = url;
  return a.href;
}

function postOpen(url, data, close) {
  var form = document.createElement('form');
  form.method = 'post';
  form.action = normalizeUrl(url);

  var input;
  for (var name in data) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = data[name];
    form.appendChild(input);
  }

  var tmpWindow = window.open('', '_blank');
  tmpWindow.document.body.appendChild(form);
  form.submit();

  if (close) {
    tmpWindow.onload = function() {
      tmpWindow.close();
    };
  }
}

function getOptions(arr, key) {
  return [...new Set(arr.map(item => +item[key]))].sort((a, b) => a - b);
}

function getOptionsAsStrings(arr, key) {
  return [...new Set(arr.map(item => item[key]))].sort();
}

function checkCondition(condition, {capacity, depth, length}) {
  return !condition || eval(condition);
}

export default {
  name: 'App',
  provide () {
    return {
      options: this.options,
      getShelvesTypeOpts: this.getShelvesTypeOpts
    };
  },
  data() {
    return {
      rows: [],
      items: null,
      role: 'user',
      inns: [],
      accessories: [],
      accessoriesByRow: [],
      wedgeAnchors: false,
      options: {
        capacity: [300, 500],
        height: [],
        depth: [],
        width: [],
        count: [3, 4, 5, 6, 7, 8, 9],
      },
    };
  },
  computed: {
    hasSections() {
      return this.rows.some(row => row.sections.length);
    },
    pdfData() {
      return JSON.stringify({
        rows: this.rows,
        accessories: this.accessories,
        accessoriesByRow: this.accessoriesByRow,
      });
    },
  },
  watch: {
    rows: {
      deep: true,
      handler: 'calc',
    },
    wedgeAnchors: 'calc',
  },
  mounted() {
    // fetch(process.env.VUE_APP_DATA_URL).then(r => r.json()).then(this.setItems);

    const xhr = new XMLHttpRequest();
    xhr.open('GET', process.env.VUE_APP_DATA_URL + '?r=' + (new Date()).getTime());
    xhr.onload = () => {
      this.setItems(JSON.parse(xhr.responseText));
    };
    xhr.send();

    var self = this;
    fetch(process.env.VUE_APP_DOMAIN_URL + '/api/calculators/', {
      method: 'post',
      body: JSON.stringify({'action': 'getRole'}),
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })
    .then(promise => promise.json())
    .then((json) => {
      console.log('Response', json);
      self.role = json.data.role;

      if (self.role === 'dealer') {
        fetch(process.env.VUE_APP_DOMAIN_URL + '/api/calculators/', {
          method: 'post',
          body: JSON.stringify({'action': 'getInns'}),
          headers: new Headers({
            'Content-Type': 'application/json'
          })
        })
        .then(promise => promise.json())
        .then((json) => {
          console.log('Response', json);
          self.inns = json.data.inns;
        })
      }
    })
  },
  methods: {
    getShelvesTypeOpts(depth, width, count, capacity) {
      const opts = ['Стандартные']
      this.items['tier_shelf'].forEach(oneShelf => {
        if (oneShelf.shelvesType === 'Сетчатые') {
          const canUse = checkCondition(oneShelf.condition, {capacity: capacity, depth: depth, length: width})
          if (opts.includes('Сетчатые') === false && canUse && depth === +oneShelf.depth) {
            opts.push('Сетчатые')
          }
        }
      })

      return opts
    },
    setItems(data) {
      data.rack_kit.sort((a, b) => b.max_shelf - a.max_shelf);
      data.tier_shelf.sort((a, b) => b.max_length - a.max_length);

      this.items = Object.freeze(data);
      this.options.height = getOptions(this.items.rack_kit, 'height');
      this.options.depth = getOptions(this.items.tier_shelf, 'depth');
      this.options.width = getOptions(this.items.beams, 'length');
      this.options.beamsType = getOptionsAsStrings(this.items.beams, 'beamsType');
      this.calc();
    },
    calc() {
      if (!this.items)
        return;

      const accessories = [];
      const accessoriesByRow = {};

      function getAccessoreObj(type, item, quantity) {
        const newobj = {
          type: type,
          id: item.id,
          name: item.name,
          price: item.price,
          quantity,
        };
        if (type === 'beams') {
          newobj.beamsType = item.beamsType
        }
        if (type === 'tier_shelf') {
          newobj.shelvesType = item.shelvesType
        }

        return newobj
      }
      function addAccessore(type, item, quantity, rowNum) {
        if (!item)
          return 0;
        quantity = parseInt(quantity)

        const accessore = accessories.find((accessore) => accessore.id === item.id);
        if (accessore) {
          accessore.quantity += quantity;
        } else {
          accessories.push(getAccessoreObj(type, item, quantity));
        }

        if (typeof accessoriesByRow[rowNum] === 'undefined') {
          accessoriesByRow[rowNum] = []
        }
        const accessore2 = accessoriesByRow[rowNum].find((accessore) => accessore.id === item.id);
        if (accessore2) {
          accessore2.quantity += quantity;
        } else {
          accessoriesByRow[rowNum].push(getAccessoreObj(type, item, quantity));
        }

        return item.price * quantity;
      }
      function isWideSection(width) {
        return width == 2400 || width == 2700;
      }

      this.rows.forEach((row, rowNum) => {
        if (row.sections.length === 0)
          return;

        let rowPrice = 0;

        const maxShelf = row.sections.reduce((a, c) => Math.max(a, c.count), 0);

        const rack_kit = this.items.rack_kit.find(rack_kit => {
          const checkMax = (rack_kit.capacity == row.capacity || rack_kit.max_shelf >= maxShelf);
          return (rack_kit.height == row.height && checkMax);
        });
        let racksCount = 2
        let linksCount = 2
        if (row.sections.length > 1) {
          if (row.separate) {
            racksCount = row.sections.length * 2
            linksCount = row.sections.length * 2
          } else {
            racksCount = row.sections.length + 1
            linksCount = row.sections.length + 1
          }
        }
        rowPrice += addAccessore('rack_kit', rack_kit, racksCount, rowNum);

        const link_kit = this.items.link_kit.find(link_kit => {
          return (link_kit.height == row.height && link_kit.depth == row.depth);
        });
        rowPrice += addAccessore('link_kit', link_kit, linksCount, rowNum);

        row.sections.forEach(section => {
          let beams = this.items.beams.find(beams => {
            return (beams.length == section.width && beams.capacity == row.capacity && beams.beamsType == section.beamsType);
          });
          if (!beams) {
            beams = this.items.beams.find(beams => {
              return (beams.length == section.width && beams.capacity == row.capacity);
            });
          }
          rowPrice += addAccessore('beams', beams, section.count * 2, rowNum);

          let tier_shelf = this.items.tier_shelf.find(tier_shelf => {
            // const isCondition = !tier_shelf.capacity || (tier_shelf.capacity == row.capacity && tier_shelf.max_length >= section.width);
            const isCondition = checkCondition(tier_shelf.condition, {capacity: row.capacity, depth: row.depth, length: section.width});
            return (tier_shelf.depth == row.depth && isCondition && tier_shelf.shelvesType == section.shelvesType);
          });
          if (!tier_shelf) {
            tier_shelf = this.items.tier_shelf.find(tier_shelf => {
              const isCondition = checkCondition(tier_shelf.condition, {capacity: row.capacity, depth: row.depth, length: section.width});
              return (tier_shelf.depth == row.depth && isCondition);
            });
          }
          section.parts = section.width / tier_shelf.length;
          rowPrice += addAccessore('tier_shelf', tier_shelf, section.count * section.parts, rowNum);
          if (section.coupler || isWideSection(section.width)) {
            const beam_coupler = this.items.beam_coupler.find(beam_coupler => {
              return (beam_coupler.depth == row.depth && beam_coupler.beamsType == section.beamsType);
            });
            const couplersCount = section.width > 1500 ? section.count * 2 : section.count;
            rowPrice += addAccessore('beam_coupler', beam_coupler, couplersCount, rowNum);
          }
        });

        if (this.wedgeAnchors) {
          const wedge_anchor = this.items.wedge_anchor[0];
          const wedgeAnchorQty = row.separate
            ? row.sections.length * 8
            : (row.sections.length + 1) * 4;
          rowPrice += addAccessore('wedge_anchor', wedge_anchor, wedgeAnchorQty, rowNum);
        }

        //side_screen
        if (row.separate) {
          row.sections.forEach(section => {
            if (section.accessories.side_screen_count > 0) {
              const side_screen = this.items.side_screen.find(side_screen => {
                return (side_screen.depth == row.depth);
              });
              rowPrice += addAccessore('side_screen', side_screen, section.accessories.side_screen_count, rowNum);
            }
          })
        } else {
          if (row.accessories.side_screen_count > 0) {
            const side_screen = this.items.side_screen.find(side_screen => {
              return (side_screen.depth == row.depth);
            });
            rowPrice += addAccessore('side_screen', side_screen, row.accessories.side_screen_count, rowNum);
          }
        }

        //back_screen
        row.sections.forEach(section => {
          if (section.accessories.back_screen_count > 0) {
            const back_screen = this.items.back_screen.find(back_screen => {
              return (back_screen.length == section.width);
            });
            rowPrice += addAccessore('back_screen', back_screen, section.accessories.back_screen_count, rowNum);
          }
        })

        row.price = rowPrice.toFixed(2);
      });

      accessories.sort((a, b) => {
        return ( ( a.name == b.name ) ? 0 : ( ( a.name > b.name ) ? 1 : -1 ) );
      })
      for (const k in accessoriesByRow) {
        accessoriesByRow[k].sort((a, b) => {
          return ( ( a.name == b.name ) ? 0 : ( ( a.name > b.name ) ? 1 : -1 ) );
        })
      }
      this.accessories = accessories;
      this.accessoriesByRow = accessoriesByRow;
    },
    print(download = false) {
      // const query = 'download=' + Number(download) + '&data=' + encodeURIComponent(this.pdfData);
      // window.open(process.env.VUE_APP_PDF_URL + '?' + query, '_blank');
      postOpen(process.env.VUE_APP_PDF_URL, {
        download: Number(download),
        data: this.pdfData,
      }, download);
    },
    download() {
      this.print(true);
    },
    addRow() {
      this.rows.push({
        capacity: 500,
        height: 2000,
        depth: 400,
        sections: [],
        price: 0,
        beamsType: 'Z-балки',
        separate: true,
        accessories: {
          side_screen: false,
          side_screen_count: 0,
        },
      });
    },
    addSection(row, data) {
      row.sections.push({
        width: +data.width,
        count: +data.count,
        parts: +data.width / 30,
        shelvesType: data.shelvesType,
        beamsType: data.beamsType,
        coupler: !!data.coupler,
        justCreatedFirstSection: data.justCreatedFirstSection ? true : false,
        accessories: {
          back_screen: false,
          back_screen_count: 0,
          side_screen: false,
          side_screen_count: 0,
        },
      });
    },
    checkDepthBackScreen(depth) {
      return [600, 800, 1000].includes(+depth);
    },
    updateRow(row, data) {
      row.capacity = +data.capacity;
      row.height = +data.height;
      row.depth = +data.depth;
      row.separate = data.separate;
      row.accessories.side_screen = data.accessories.side_screen;
      row.accessories.side_screen_count = data.accessories.side_screen ? Math.max(1, data.accessories.side_screen_count) : 0;

      if (this.checkDepthBackScreen(row.depth) === false) {
        let needAlert = false
        row.sections.forEach(section => {
          if (section.accessories.side_screen_count > 0) {
            needAlert = true
            section.accessories.side_screen = false
            section.accessories.side_screen_count = 0
          }
        })
        if (row.accessories.side_screen_count > 0) {
          needAlert = true
          row.accessories.side_screen = false
          row.accessories.side_screen_count = 0
        }
        if (needAlert) {
            alert("Ранее вы выбрали боковые экраны в этом ряду, \nСейчас они убраны, т.к.\nбоковые экраны могут быть добавлены только для секций с глубиной:\n600/800/1000")
        }
      }
      if ([600, 800, 1000].includes(+row.depth) === false) {
        let needAlert = false
        row.sections.forEach(section => {
          if (section.shelvesType === 'Сетчатые') {
            needAlert = true
            section.shelvesType = 'Стандартные'
          }
        })
        if (needAlert) {
            alert("Ранее вы выбрали сетчатые полки в этом ряду, \nСейчас они заменены на стандартные, т.к.\nсетчатые полки могут быть использованы только для секций с глубиной:\n600/800/1000")
        }
      }
      if (row.sections[0]) {
        row.sections[0].width = +data.width;
        row.sections[0].count = +data.count;
      } else {
        const dataForCreation = Object.assign({}, data);
        dataForCreation.shelvesType = 'Стандартные'
        dataForCreation.beamsType = 'Z-балки'
        dataForCreation.coupler = false
        dataForCreation.justCreatedFirstSection = true
        this.addSection(row, dataForCreation);
      }
    },
    copyRow(row, idx, count) {
      for (let i = 0; i < count; i++) {
        const newRow = {
          accessories: {
            side_screen: row.accessories.side_screen,
            side_screen_count: row.accessories.side_screen_count
          },
          beamsType: row.beamsType,
          capacity: row.capacity,
          height: row.height,
          depth: row.depth,
          price: row.price,
          sections: row.sections.map((section) => ({...section})),
          separate: row.separate,
        };
        this.rows.splice(idx + 1, 0, newRow);
      }
      this.calc();
    },
    removeRow(row, i) {
      this.rows.splice(i, 1);
    },
    updateSectionHandler(row, section) {
      if (section.index == 0) {
        row.beamsType = section.beamsType
      }
    }
  },
  components: {
    Welcome,
    Row,
    AddRow,
    Accessories,
    EmailModal,
    DealerModal,
    InvoiceModal,
  },
}
</script>

<style>
  button {
    padding: 16px 32px;
    font-size: 16px;
    line-height: 18px;
    color: white;
    background: #F58214;
    border: none;
  }
</style>
